import React, { useEffect, useState } from "react";

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]); //set size in state
    };
    // handleWindowResize()
    // console.log("screen size",windowSize)
    window.addEventListener("resize", handleWindowResize);
  }, []);

  return [windowSize[0], windowSize[1]];
};

export default useWindowSize;
